import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';
import { router } from './routes';
import { ErrorBoundary } from './components/ErrorBoundary';

export default function App() {
  return (
    <ErrorBoundary>
      <RouterProvider router={router} />
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: 'var(--mg-bg-elevated)',
            color: 'var(--mg-text)',
            border: '1px solid var(--mg-border)',
            fontFamily: 'var(--mg-font-body)',
          },
        }}
      />
    </ErrorBoundary>
  );
}
